import styled from 'styled-components';
import { rem } from 'polished';
var ForgotPasswordLinkContainer = styled.div.withConfig({
  displayName: "ForgotPasswordLinkContainer",
  componentId: "sc-1u1yczd-0"
})(["padding-top:", ";text-align:right;width:100%;"], rem(16));
export default ForgotPasswordLinkContainer;